import React from 'react'

import styled from 'styled-components'
import Link from 'components/Link'
import media from 'utils/media'
import { DEFAULT_LANG } from 'config/languages'
export default function DesktopMenu({ menu, lang, path }) {
   return (
      <StyledWrapper>
         {Array.isArray(menu) &&
            menu.map((item) => {
               if (item.type === 'internal') {
                  const linkUrl = lang === DEFAULT_LANG ? item.url : `/${lang}${item.url}`

                  return (
                     <li key={item.id}>
                        <StyledLink type={item.type} url={linkUrl} id={`desktop_${item.id}`}>
                           <span>/</span>
                           <span>{item.title}</span>
                        </StyledLink>
                     </li>
                  )
               }
               return (
                  <li key={item.id}>
                     <StyledLink type={item.type} url={item.url} id={`desktop_${item.id}`}>
                        <span>/</span>
                        <span>{item.title}</span>
                     </StyledLink>
                  </li>
               )
            })}
      </StyledWrapper>
   )
}

const StyledWrapper = styled.ul`
   display: none;
   color: ${({ theme }) => (theme.darkMode ? theme.colors.white : theme.colors.accent)};

   ${media.greaterThan('lg')`
      margin-left: 12px;
      display: flex;
      gap: 27px;
   `};

   li {
      margin-bottom: 0;
   }
`

const StyledLink = styled(Link)`
   display: block;
   font-size: 16px;
   font-family: ${({ theme }) => theme.fonts.portrait};

   span:first-of-type {
      display: inline-block;
      color: ${({ theme }) => theme.colors.hotCinnamon};
      opacity: 0;
      transition: transform 0.2s linear, opacity 0.2s linear;
      font-family: "Arial";
      font-weight: 700;
   }

   span:last-of-type {
      transform: translateX(0);
      display: inline-block;
      transition: transform 0.2s linear, opacity 0.2s linear;
   }

   &:hover {
      span:first-of-type {
         opacity: 1;
      }

      span:last-of-type {
         transform: translateX(6px);
      }
   }
`
